module.exports = __webpack_public_path__ + "static/media/IMG_1633.a2b0172d.JPG";